import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import frenchMessages from "ra-language-french";
import danishMessages from "ra-language-danish";
import swedishMessages from "@kolben/ra-language-swedish";
import finnishMessages from "ra-language-finnish";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { raSupabaseFrenchMessages } from "ra-supabase-language-french";
import { englishCrmMessages } from "./englishCrmMessages";
import { frenchCrmMessages } from "./frenchCrmMessages";
import { danishCrmMessages } from "./danishCrmMessages";
import { swedishCrmMessages } from "./swedishCrmMessages";
import { finnishCrmMessages } from "./finnishCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const raSupabaseFrenchMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Consultez vos emails pour trouver le message de reinitialisation du mot de passe.",
    },
  },
};

const raSupabaseDanishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Tjek din e-mail for en besked om nulstilling af adgangskode.",
    },
  },
};

const raSupabaseSwedishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Kontrollera din e-post för ett meddelande om återställning av lösenord.",
    },
  },
};

const raSupabaseFinnishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Tarkista sähköpostistasi salasanan nollausviesti.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

const frenchCatalog = mergeTranslations(
  englishCatalog,
  frenchMessages,
  raSupabaseFrenchMessages,
  raSupabaseFrenchMessagesOverride,
  frenchCrmMessages,
);

const danishCatalog = mergeTranslations(
  englishCatalog,
  danishMessages,
  raSupabaseDanishMessagesOverride,
  danishCrmMessages,
);
const swedishCatalog = mergeTranslations(
  englishCatalog,
  swedishMessages,
  raSupabaseSwedishMessagesOverride,
  swedishCrmMessages,
);
const finnishCatalog = mergeTranslations(
  englishCatalog,
  finnishMessages,
  raSupabaseFinnishMessagesOverride,
  finnishCrmMessages,
);

export const getInitialLocale = (): "en" | "fr" | "da" | "sv" | "fi" => {
  if (typeof navigator === "undefined") {
    return "en";
  }

  const browserLocale = (
    navigator.languages?.[0] ??
    navigator.language ??
    ""
  ).toLowerCase();
  if (browserLocale.startsWith("fr")) return "fr";
  if (browserLocale.startsWith("da")) return "da";
  if (browserLocale.startsWith("sv")) return "sv";
  if (browserLocale.startsWith("fi")) return "fi";
  return "en";
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "fr") return frenchCatalog;
    if (locale === "da") return danishCatalog;
    if (locale === "sv") return swedishCatalog;
    if (locale === "fi") return finnishCatalog;
    return englishCatalog;
  },
  getInitialLocale(),
  [
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
    { locale: "da", name: "Dansk" },
    { locale: "sv", name: "Svenska" },
    { locale: "fi", name: "Suomi" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
